import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IRecommendationAdjustedTask } from '../../../../../interfaces/route-recommendations/recommendation-task';
import { VehicleRegComponent } from '../../../../vehicle-reg/vehicle-reg.component';
import { RouterLinkWithHref } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-itinerary-task-detail',
  templateUrl: './route-itinerary-task-detail.component.html',
  styleUrls: [
    './route-itinerary-task-detail.component.scss',
    '../../common/scss/route-itinerary-common.scss',
  ],
  standalone: true,
  imports: [VehicleRegComponent, RouterLinkWithHref, CommonModule],
})
export class RouteItineraryTaskDetailComponent {
  @Input() task: IRecommendationAdjustedTask;
  @Input() expanded: boolean = false;
  @Output() viewDirectionLink = new EventEmitter<void>();
  @Output() expanderToggle = new EventEmitter<void>();
}
